import type { FunctionComponent } from "react";
import { Button } from "../../ui/button";
import { useToast } from "../../../hooks/use-toast";
import { handleHttpError } from "../../../utils/utils";
import Spinner from "../../spinner.components";
import { useSendTestNotificationAdminHttp } from "../../../hooks/http/admin/notifications/send-test-notifications.admin.http";
import type { ISocial } from "../../../types/models/social.models.types";

type AppProps = {
	title: string;
	description: string;
	social: ISocial;
};

export const SendTestNotificationButton: FunctionComponent<AppProps> = ({
	title,
	description,
	social,

}) => {
	const {
		execute: sendTestNotificationHttp,
		fetching: sendingTestNotification,
	} = useSendTestNotificationAdminHttp();

	const { toast } = useToast();

	async function sendTestNotification() {
		if (!social.creator?.id) {
			return;
		}
		const response = await sendTestNotificationHttp({
			body: {
				notificationType: "fcm",
				title,
				description,
				creators: [social.creator.id],
			},
		});
		if (!response.success) {
			return handleHttpError(response, toast);
		}
		toast({
			content: "Test notification sent successfully",
			toastType: "success",
		});
	}

	return (
		<Button
			disabled={sendingTestNotification}
			onClick={() => {
				sendTestNotification();
			}}
			type="button"
			className="bg-tertiarybuttonbg border border-border w-28 font-semibold"
		>
			{sendingTestNotification ? <Spinner width={15} /> : "Send test"}
		</Button>
	);
};
